// src/Pages/PartySecret.jsx
import React from 'react';
import styled from 'styled-components';
import villa from '../Assets/birthday-party/birthday-villa-0.png';
import plane from "../Assets/birthday-party/plane.png";
import wine from "../Assets/birthday-party/4.png";
import villa0 from "../Assets/birthday-party/5.png";
import town from "../Assets/birthday-party/6.png";
import grapes from "../Assets/birthday-party/7.png";
import quill from "../Assets/birthday-party/8.png";

import squiggle from '../Assets/birthday-party/squiggle.svg';

const Wrapper = styled.div`
  background: #fffdee;
  min-height: 260px;
  padding: 28px;
  border-radius: 12px;
  color: #11676a;
  box-shadow: 0 8px 20px rgba(40, 15, 145, 0.06);
`;

const Header = styled.h1`
  margin: 0 0 18px 0;
  font-size: 4rem;
  color: #11676a;
  text-align: center;
  font-family: 'Cedarville Cursive', cursive;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 320px 1fr;
  gap: 18px;
  align-items: center;
  max-width: 1000px;
  margin: 0 auto;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    & > .image {
      order: -1; /* image first on mobile */
      margin-bottom: 12px;
    }
  }
`;

const Column = styled.div`
  text-align: ${props => (props.center ? 'center' : 'left')};
`;

/* Plain date block (no bg, no border, no shadow) */
const DateBlock = styled.div`
  padding: 8px 0;
  color: #11676a;
  background: transparent;
  border: none;
  text-align: left;

  @media (max-width: 767px) {
    text-align: center; /* center on mobile */
  }
`;

/* Plain img wrapper */
const Img = styled.img`
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  display: block;
  margin: 0 auto;
`;

/* Plain venue text block (no bg/border/shadow) */
const Venue = styled.div`
  padding: 8px 0;
  color: #11676a;
  background: transparent;
  border: none;
  text-align: right;

  @media (max-width: 767px) {
    text-align: center; /* center on mobile */
    padding-top:5px;
  }
`;

const Row = styled.div`
  margin-top: 18px;
  display: flex;
  gap: 12px;
  justify-content: center;
  align-items: center;
`;

const Action = styled.button`
  background: #11676a;
  color: #fff9d2;
  padding: 10px 18px;
  border-radius: 999px;
  border: none;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 6px 18px rgba(40, 15, 145, 0.12);
  transition: transform 140ms ease;
  &:hover { transform: translateY(-3px); }
`;

/* Squiggle styles: mirror on right; hide mirrored squiggle on mobile */
const Squiggle = styled.img`
  display: inline;;
  margin-top: 8px;
  height: 22px;
  text-align: left;
    @media (max-width: 767px) {
    display: none; /* hide on mobile */
  }
`;

const SquiggleMirror = styled(Squiggle)`
  transform: scaleX(-1);
  text-align: right !important;

  @media (max-width: 767px) {
    display: none; /* hide on mobile */
  }
`;

const Heading = styled.h2`
  margin: 0 0 18px 0;
  font-size: 2rem;
  color: #11676a;
  text-align: center;
  font-family: 'Cedarville Cursive', cursive;
`;

const BodyText = styled.div`
    color: #11676a;
`

const PageBody = styled.div`
    margin: 0 1rem;
    max-width:800px;
        @media (min-width: 767px) {
        margin: 0 auto;
  }
`;

const H2Image = styled.img`
    background-image: url(${src => src});
     height: 5rem;
  display: block;
    margin: 0 auto;
  background-size: cover;
  background-position: center;
`;

const Dropbtn = styled.button`
  background: #11676a;
  color: #fff9d2;
  padding: 10px 18px;
  border-radius: 999px;
  border: none;
  font-weight: 700;
  min-width:250px;
  text-align:center;
  margin: 0 auto;
  cursor: pointer;
  box-shadow: 0 6px 18px rgba(40, 15, 145, 0.12);
`;
const DropdownContent = styled.div`
  display: none;
  position: absolute;
  background-color: #fffffc;
  min-width: 300px;
  max-width: 400px;
  transform: translateX(-50%);
  left: 50%;
  margin: 0 auto;
  text-align: left;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
  
`;
const Dropdown = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
  text-align: center;
  margin: 20px 0;
  
  &:hover ${DropdownContent} {
    display: block;
  }
    & a {
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    border-bottom: 1px solid #11676a;
    }
    & a:hover{
      background-color: #11676a;
      color: #fff9d2;
      }
`;

const ScrollToTopButton = styled.button`
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 50px;
  height: 50px;
  border: none;
  border-radius: 50%;
  background-color: #11676a; /* Change to your preferred color */
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 1000; /* Ensure it stays on top */
  
  &:hover {
    background-color: #0c484aff; /* Darker shade on hover */
  }
`;

const Chevron = styled.span`
  display: inline-block;
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 3px;
  transform: rotate(225deg);
  width: 10px;
  height: 10px;
`;

export default function PartySecret({ onLogout, setStatusMsg }) {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Wrapper role="region" aria-labelledby="secret-title">
      <Header id="secret-title">Laura's 40th Birthday</Header>

      <Grid>
        <Column>
          <DateBlock>
            <p style={{margin:0}}>16th-19th October 2026</p>
            <Squiggle src={squiggle} alt="" aria-hidden="true" />
          </DateBlock>
        </Column>

        <Column className="image" center>
          <Img src={villa} alt="Birthday villa graphic" />
        </Column>

        <Column>
          <Venue>
            <p style={{margin:0}}>Verona, Italy</p>
            <SquiggleMirror src={squiggle} alt="" aria-hidden="true" />
          </Venue>
        </Column>
      </Grid>
      <PageBody>
        <Dropdown>
        <Dropbtn>Jump to...</Dropbtn>
            <DropdownContent>
                <a href="#the-plan">The Plan</a>
                <a href="#the-villa">The Villa</a>
                <a href="#other-accommodation">Other Accommodation</a>
                <a href="#getting-there">Getting There</a>
                <a href="#getting-there">FAQ</a>
                <a href="#rsvp">RSVP</a>
            </DropdownContent>
        </Dropdown>

      <Heading>
        You're invited!
      </Heading>
      
      <BodyText>
        <h3>Update 17/02/2026: Villa rooms are now booked!</h3>
        <p><i>Thank you to everyone who's already confirmed they're coming! I wish I could have found somewhere to fit everyone, but I've seen some great alternatives in Avesa near the villa. If you're looking for somewhere nearby, drop me a line and I can put you in touch with others who may want to team up.</i></p>
        <br />
        <p>
            So, I'm turning 40 this year. And as much as I'm in denial about it, it's happening. True to form, I've decided to spend my midlife crisis in Italy.
        </p>
        <p>
            I think it's such a shame that weddings are usually the only time in our lives that we get to gather everyone important to us in one place. I want to change that. 
            I want to have the people I love most in the country I love most to celebrate together.
        </p>
        <p>
            I've rented a gorgeous villa just outside Verona, and on the night of my birthday, we'll all gather there, and have a chef in the kitchen preparing a dinner for all of us. If you're reading this, it's because you matter to me and I'd love to have you there.
        </p>
      </BodyText>

      <Heading id="the-plan">
        The Plan
      </Heading>
            <H2Image src={wine} />
      <BodyText>
        <p>We have the villa from <b>Friday, October 16th to Monday, October 19th</b>. You're welcome to join for the full long weekend, or just for the main event on the <b>evening of Saturday the 17th</b>, whatever works best for you.</p>
        <p>I'm aware I'm asking you for a weekend of your time, so outside of the Saturday dinner, I want you to have the weekend <i>you</i> want.</p>
        <ul>
            <li><b>Explore Verona:</b> It's a 20 minute drive, or about half an hour by bus from the villa. Go see Juliet's balcony, the Arena, or just wander the streets.</li>
            <li><b>Relax at the villa:</b> There's a pool, garden, and plenty of spots to lounge with a book and a glass of wine.</li>
            <li><b>See the vineyards:</b> We'll be right by the Valpolicella valley, and very close to Soave. We're also in the region Prosecco comes from.</li>
            <li><b>Explore further afield:</b> Lake Garda is about a 40 minute drive or there's a (very irregular) bus from Verona, Venice about 1.5 hours, and Milan about 2 hours.</li>
        </ul>
        <p>Essentially, you can arrive whenever you want, and spend your time however you like. Aleks and I will be in Verona from either Thursday night or Friday morning, and leaving on Monday.</p>
      </BodyText>
      <Heading id="the-villa">
        Staying at the Villa
      </Heading>
      <H2Image src={villa0} />
      <BodyText>
        <p>
            I have booked a villa in Avesa, just outside Verona, for 3 nights. I'm asking for a contribution of <b>£150 per room</b> for the weekend, and I will be covering the rest. If you stay all 3 nights, that works out at £50 a night.
        </p>
        <ul>
            <li><b>The Rooms:</b>There are 6 guest rooms in the villa. These are now full, but there are some great options around Avesa or in Verona itself. If you're not staying in the villa, I'm happy to put you in touch with others if you want to team up for a place nearby! </li>
            <li><b>Saturday Night Dinner:</b> The birthday dinner with the chef is my gift to you, to thank you for being there with me. It truly does mean so much.</li>
            <li><b>Reserved Rooms: </b> To keep things fair, the six available rooms were allocated to the first people to confirm they were in and transfer the contribution.</li>
        </ul>
      </BodyText>
      <Heading id="other-accommodation">
        Staying Elsewhere
      </Heading>
            <H2Image src={town} />
      <BodyText>
        <p>
        If you'd prefer a hotel, the villa rooms are already full, or you can't commit until later then there are plenty of options in Verona or in Avesa, where the villa is based.
        </p>
        <p>
            Even if you're not staying at the villa, you're still very much a part of the birthday dinner, and included in any other part of the weekend. You're still wanted and welcomed!
        </p>
      </BodyText>
        <Heading id="getting-there">
        Getting There
        </Heading>
        <H2Image src={plane} />
      <BodyText>
        <p>
            Verona Valerio Catullo Airport (VRN) is the closest airport, about a 20 minute drive from the villa. If you're coming by public transport, there are regular shuttles from the Airport to Porta Nuova Station (about 15 minutes journey), and from there the bus on to Avesa is around 20 minutes. 
        </p>
        <p>
            Verona airport has regular flights with Ryanair, EasyJet and Jet2. There are regular direct flights from London and Dublin. If you're coming from elsewhere, Milan (MXP), Venice (VCE) or Treviso (TSF) are alternate options, each taking about another 2.5 hours onward to Avesa.
        </p> 
      </BodyText>
        <Heading id="faq">
        FAQ
        </Heading>
              <H2Image src={grapes} />
      <BodyText>
        <p>
            Since I'm already being extra making a whole website, here's some more bits you may be wondering about:
        </p> 
        <ul>
            <li>
                <b>What time is birthday dinner?</b>
                <ul>
                    <li>TBC once I confirm with the chef, but expect around 7pm.</li>
                </ul>
            </li>
            <li>
                <b>What about dietary requirements?</b>
                <ul>
                    <li>The birthday dinner will be 100% plant-based. Please let me know if you have any allergies or requirements I don't already know about!</li>
                    <li>Outside of the birthday dinner, the weekend is self-catering, so you're free to use the villa kitchen or eat out and have whatever you please.</li>
                </ul>
            </li>
            <li>
                <b>Can I bring a +1?</b>
                <ul>
                    <li>Villa capacity is limited, and I really want this to be a gathering of the people I love most, so invites are limited to those named in the WhatsApp I sent you. If you're not sure, just drop me a message.</li>
                </ul>
            </li>
            <li>
                <b>Do I need to rent a car?</b>
                <ul>
                    <li>Look, we all know I haven't bothered my hole getting a driver's license in 40 years, so the villa is accessible via public transport.</li>
                    <li>If you want to rent one, feel free — there is parking on-site, and I'm happy to check any specific details with the owners for you.</li>
                </ul>
            </li>
            <li>
                <b>What if my plans change?</b>
                <ul>
                    <li>If you're staying in the villa, I can only return contributions if there is someone else to fill the room.</li>
                    <li>If you can no longer make it, let me know ASAP and I’ll see if anyone else wants to move into the villa.</li>
                    <li>Please let me know as early as possible — most chefs have a "final numbers" date at least a month out, which helps me plan accordingly.</li>
                </ul>
            </li>
        </ul>
      </BodyText>
      <Heading id="rsvp">
        RSVP
      </Heading>
            <H2Image src={quill} />
      <BodyText>
        <p>I'd love to see you in Verona this October. Please RSVP by email or WhatsApp by <b>17th August 2026</b></p>
        <p>
             Message me on WhatsApp<br />
        <a href="mailto:laurahannawhite@gmail.com">Email me at laurahannawhite@gmail.com</a>
        </p>
      </BodyText>
      </PageBody>
      <Row>

        <Action
          type="button"
          onClick={() => onLogout && onLogout()}
          aria-label="Logout"
        >
          Logout
        </Action>
      </Row>
      <ScrollToTopButton onClick={scrollToTop}>
        <Chevron />
      </ScrollToTopButton>
    </Wrapper>
  );
}